import ActionBtn from '@/components/ActionBtn'
import ScreenHeader from '@/components/ScreenHeader'
import { REQUEST_STATUS } from '@/data/Constant'
import { useMemo } from 'react'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import './style.css'
import { Block } from '@/components/crRender'

// GetPatientMedicalAttachments

// const getId = (i) => i?.medicalOrderId || i?.orderId || i?.requestId || i?.id || i?.brokerPatientId

const TableHeader = ({ selectedItems = [], hospitalRef, requests = false }) => {
  const { t } = useTranslation()

  const isInvalid = useMemo(() => {
    // if (!selectedItems.length) return 'select-at-least-one'
    // if (selectedItems.some(item => !item?.attachments?.length)) return 'ask-quotation-missing-docs'
    // if (selectedItems.some(item => item?.orderStatusId === REQUEST_STATUS.PendingRequest))
    //   return 'ask-quotation-invalid-status'
    return null
  }, [selectedItems])

  const handleSubmit = () => {
    if (isInvalid) return toast.error(t(isInvalid))
    console.log(selectedItems)
    hospitalRef?.current?.click()
  }

  return (
    <ScreenHeader title="Medical Requests Pipeline" subtitle="medical-requests-subtitle">
     <Block
     isRender={requests}
     >
      <div className="actions-container am-actions">
        <ActionBtn
          className="broker-actions submit"
          title="ask-for-quotation"
          icon={'prime:send'}
          onApply={handleSubmit}
        />
        
      </div>
     </Block>
    </ScreenHeader>
  )
}

export default TableHeader